import React from 'react';
import { RichText } from 'prismic-reactjs';
import { useStaticQuery } from 'gatsby';
import { StyledTighterLargeText } from './tighter-large-text.styled';
var TighterLargeText = function TighterLargeText(_ref) {
    var richText = _ref.richText, color = _ref.color, customStyles = _ref.customStyles;
    var _useStaticQuery = useStaticQuery("942536103"), prismicStylesConfig = _useStaticQuery.prismicStylesConfig;
    return /*#__PURE__*/ React.createElement(StyledTighterLargeText, {
        color: color,
        customStyles: customStyles,
        configStyles: prismicStylesConfig.data.large_text_tighter_line_height_styles.text
    }, /*#__PURE__*/ React.createElement(RichText, {
        render: richText
    }));
};
export default TighterLargeText;
